export default "__VITE_ASSET__d8858f97__"